import React from "react";
import {Box, Typography} from "@material-ui/core";
import strings from "../../../../../../../../strings";
import TableComponent from 'components/shared/TableComponent'
import {Col, Row} from "react-bootstrap";
import {AmendmentDetailsColumns, DebtorsColumn, FilingDetailsColumns} from 'constants/application'
import FilingDetailsContainerHeader from "./FilingDetailsContainerHeader";
import RoxAccordion from "../../../../../../../shared/RoxAccordion";
import Paper from "@material-ui/core/Paper";

const FilingDetailsContainerAccordion = ({selectedFilings, item, handleReportSelect, nonSelectableRows}) => {
    function getEntityRow(name, data) {
        return <Row className="mb-3">
            <Typography className='bold-font'>{name}</Typography>
            <TableComponent
                title={name}
                columns={DebtorsColumn}
                showPagination={false}
                data={data || []}
                keyField='Name'
            />
        </Row>;
    }

    /**
     * Filters and sorts collateral statements by their SortOrder.
     * Excludes statements that have no text content or only whitespace.
     */
    const getSortedCollateralStatements = (statements) => {
        if (!statements || statements.length === 0) return [];
        return [...statements]
            .filter(statement => statement.Text && statement.Text.trim() !== '')
            .sort((a, b) => parseInt(a.SortOrder) - parseInt(b.SortOrder));
    };

    return (
        <RoxAccordion
            expanded={false}
            summary={<FilingDetailsContainerHeader item={item} />}
            details={<Col>
                <Row className="mb-3">
                    <TableComponent
                        keyField={'FilingNumber'}
                        columns={FilingDetailsColumns}
                        data={[item]}
                        showPagination={false}
                        selectRow={{
                            mode: 'checkbox',
                            hideSelectAll: true,
                            onSelect: (row, isSelect) => handleReportSelect(row, isSelect),
                            selected: selectedFilings || [],
                            nonSelectable: nonSelectableRows
                        }}
                    />
                </Row>
                {getEntityRow(strings.APPLICANT.UCC.DEBTORS, item?.Debtors)}
                {getEntityRow(strings.APPLICANT.UCC.SECUREDS, item?.Secureds)}

                {/* Collateral Statements Section */}
                {item?.CollateralStatements && item.CollateralStatements.length > 0 && (
                    <Row className="mb-3">
                        <Typography className='bold-font'>{strings.COLLATERAL} Statements</Typography>
                        <Col style={{ width: '100%' }}>
                            {getSortedCollateralStatements(item?.CollateralStatements).length > 0 ? (
                                getSortedCollateralStatements(item.CollateralStatements).map((statement, index) => (
                                    <Paper
                                        key={statement.SortOrder || index}
                                        variant="outlined"
                                        style={{
                                            padding: '12px 16px',
                                            marginTop: '8px',
                                            backgroundColor: 'var(--bg-canvas)',
                                            borderRadius: '4px'
                                        }}
                                    >
                                        <Box display="flex" alignItems="flex-start">
                                            <Typography
                                                variant="body2"
                                                style={{
                                                    fontWeight: 'bold',
                                                    marginRight: '12px',
                                                    minWidth: '24px',
                                                    color: '#666'
                                                }}
                                            >
                                                {statement.SortOrder || index + 1}.
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                style={{
                                                    whiteSpace: 'pre-wrap',
                                                    wordBreak: 'break-word',
                                                    lineHeight: 1.6
                                                }}
                                            >
                                                {statement.Text}
                                            </Typography>
                                        </Box>
                                    </Paper>
                                ))
                            ) : (
                                <Typography
                                    variant="body2"
                                    style={{
                                        color: '#666',
                                        fontStyle: 'italic',
                                        marginTop: '8px'
                                    }}
                                >
                                    No collateral statements available
                                </Typography>
                            )}
                        </Col>
                    </Row>
                )}

                <Row className="mb-3">
                    <Typography className='bold-font'>{strings.APPLICANT.UCC.AMENDMENTS}</Typography>
                    <TableComponent
                        keyField='FilingNumber'
                        title='Amendments'
                        columns={AmendmentDetailsColumns}
                        showPagination={false}
                        data={item?.Amendments || []}
                        selectRow={{
                            mode: 'checkbox',
                            hideSelectAll: true,
                            onSelect: (row, isSelect) => handleReportSelect(row, isSelect),
                            selected: selectedFilings || [],
                            nonSelectable: nonSelectableRows
                        }}
                    />
                </Row>
            </Col>}
        />
    )
}

export default FilingDetailsContainerAccordion;